function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'forest-green': 'rgb(119, 145, 117)','stormy-blue': 'rgb(107, 128, 156)','midnight-black': 'rgb(0, 0, 0)','silver': 'rgb(192, 192, 192)','carbon': 'rgb(98, 93, 93)',};

    this.images = {'anthony': 'url("//checkout.buggypitstop.co.uk/cdn/shop/files/Anthony_68x.png?v=12575588731001439921")','alice': 'url("//checkout.buggypitstop.co.uk/cdn/shop/files/Alice_68x.png?v=6191551527273631360")','declan': 'url("//checkout.buggypitstop.co.uk/cdn/shop/files/Declan_68x.png?v=4327968373596419529")','gregory': 'url("//checkout.buggypitstop.co.uk/cdn/shop/files/Gregory_68x.png?v=5279747273005195870")','greyson': 'url("//checkout.buggypitstop.co.uk/cdn/shop/files/Greyson_68x.png?v=5832562814403608675")','gwen': 'url("//checkout.buggypitstop.co.uk/cdn/shop/files/Gwen_68x.png?v=4623937025988733243")','jake': 'url("//checkout.buggypitstop.co.uk/cdn/shop/files/Jake_68x.png?v=17959040450633242097")','lucy': 'url("//checkout.buggypitstop.co.uk/cdn/shop/files/Lucy_68x.png?v=12890190000146537467")','liam': 'url("//checkout.buggypitstop.co.uk/cdn/shop/files/Liam_68x.png?v=518603673750327784")','noa': 'url("//checkout.buggypitstop.co.uk/cdn/shop/files/Noa_68x.png?v=15052024475965183079")','theo': 'url("//checkout.buggypitstop.co.uk/cdn/shop/files/Theo_68x.png?v=17802845827831535985")','stella': 'url("//checkout.buggypitstop.co.uk/cdn/shop/files/Stella_68x.png?v=27722443013814813")','charlotte': 'url("//checkout.buggypitstop.co.uk/cdn/shop/files/Charlotte_68x.png?v=12371376578922761498")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
